export const TRIP_STATUS = {
  cancelled: 'CANCELLED',
  onTheWay: 'ON_THE_WAY',
  tripStarted: 'TRIP_STARTED',
  tripEnded: 'TRIP_ENDED',
  aborted: 'ABORTED',
  booked: 'BOOKED',
  scheduled: 'SCHEDULED',
};